import {
  queryFamiliesByFamilyIdRange as queryFamiliesByFamilyIdRangeApi
  , queryFamiliesByArea as queryFamiliesByAreaByApi
  , queryFamilyMembers as queryFamilyMembersApi
  , queryFamiliesCount as queryFamiliesCountApi
} from "./SpatApi";
import { showErrorToast, } from "../utils/Toasts";

export async function queryFamiliesByFamilyIdRange(queryParams) {
  try {
    const response = await queryFamiliesByFamilyIdRangeApi(queryParams);
    if (response?.status === 201 || response?.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while queryinh family details.");
    return false;
  }
}

export async function queryFamiliesByArea(queryParams) {
  try {
    const response = await queryFamiliesByAreaByApi(queryParams);
    if (response?.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while querying families.");
    return false;
  }
}

export async function queryFamilyMembers(queryParams) {
  try {
    const response = await queryFamilyMembersApi(queryParams);
    if (response?.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while querying family members.");
    return false;
  }
}


export async function queryFamiliesCount(queryParams) {
  try {
    const response = await queryFamiliesCountApi(queryParams);
    if (response?.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while queryinh family details.");
    return false;
  }
}

